import { type ReactNode, useId } from "react";
import { tui } from "../locale";
import { useEnabledToolsState } from "../store/useWorkspaceToolsStore";
import { UnpublishedDot } from "./UnpublishedDot";

/** `describedBy` explains the dot to a keyboard user, who cannot hover it. */
export type ManageItemTools = { indicator: ReactNode; describedBy?: string };

export type WorkspaceToolsManageProps = {
	catalogItem: (tools?: ManageItemTools) => ReactNode;
};

export const WorkspaceToolsManage = ({ catalogItem }: WorkspaceToolsManageProps) => {
	const state = useEnabledToolsState();
	const descriptionId = useId();
	if (!state) return <>{catalogItem()}</>;
	if (state.unpublished <= 0) return <>{catalogItem({ indicator: null })}</>;

	return (
		<>
			{catalogItem({ indicator: <UnpublishedDot />, describedBy: descriptionId })}
			<span hidden id={descriptionId}>
				{tui("unpublished")}
			</span>
		</>
	);
};
